import React from 'react';
import MaskedInput from 'react-input-mask';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { validateRequired } from 'utils/form';
import { InputFieldProps } from './InputField';

interface MaskedInputFieldProps extends InputFieldProps {
	mask: string;
}

export const MaskedInputField = ({
	value,
	name = '',
	mask,
	...props
}: MaskedInputFieldProps) => {
	const { t } = useTranslation('errors');
	const [inputValue, setInputValue] = React.useState(value);
	const { register, errors } = useFormContext();

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		setInputValue(e.target.value);
	}
	return (
		<MaskedInput
			value={inputValue}
			name={name}
			mask={mask}
			onChange={handleChange}
			alwaysShowMask={false}
			maskChar={null}
		>
			{(maskedProps: { name: string; value: string }) => (
				<div className={`group ${props.wrapperClass}`}>
					<input
						ref={register({
							...validateRequired(props.required, t('required')),
						})}
						name={maskedProps.name}
						type={props.type}
						id={props.id}
						autoComplete={props.autoComplete}
						className="group__input"
						placeholder=" "
						onBlur={props.onBlur}
					/>
					<div
						className="group__label-bg"
						data-label={props.required ? `${props.label}*` : props.label}
					/>
					<label className="group__label" htmlFor={props.id}>
						{props.required ? `${props.label}*` : props.label}
					</label>
					<p
						className={`group__hint font-caption ${
							errors?.[name]?.message ? 'group__hint--error' : ''
						}`}
					>
						{errors?.[name]?.message || props.hintText}
					</p>
				</div>
			)}
		</MaskedInput>
	);
};
